export default __webpack_public_path__ + "static/media/newvideocut.5f15f248.mkv";